// Build version: v2-2026-05-20-explore-routing (forces fresh bundle)
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import App from "./App";
import Logbook from "./Logbook";
import IndyPicks from "./IndyPicks";
import Scoreboard from "./Scoreboard";
import Backtest from "./Backtest";
import Backtest2 from "./Backtest2";
import ForwardTest from "./ForwardTest";
import ForwardTest2 from "./ForwardTest2";
import GT2 from "./GT2";
import NewMemberView from "./NewMemberView";
import Signal from "./Signal";
import Intake from "./Intake";
import Intake2 from "./Intake2";
import Top10 from "./Top10";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Root + any unknown URL -> GT2 marketing frontdoor (passcode gate) */}
        <Route path="/" element={<Navigate to="/newmemberview" replace />} />
        {/* Analyst home (private, soft-secret URL) */}
        <Route path="/explore" element={<App />} />
        {/* Explore2 (coiling/BOWL watchlist) retired → send any old links to the live screener */}
        <Route path="/explore2" element={<Navigate to="/explore" replace />} />
        <Route path="/logbook" element={<Logbook />} />
        <Route path="/indypicks" element={<IndyPicks />} />
        <Route path="/scoreboard" element={<Scoreboard />} />
        <Route path="/backtest" element={<Backtest />} />
        <Route path="/backtest2" element={<Backtest2 />} />
        <Route path="/ffsystemlive" element={<ForwardTest />} />
        <Route path="/ffsystemlive2" element={<ForwardTest2 />} />
        <Route path="/gt2" element={<GT2 />} />
        {/* GT3 — The Signal: QQQ single sleeve + Consensus Shutter (beta) */}
        <Route path="/signal" element={<Signal />} />
        <Route path="/serene" element={<Navigate to="/signal" replace />} />
        <Route path="/gt3" element={<Navigate to="/signal" replace />} />
        {/* Phase 3 — Triangulated Intake Diagnostic. Member passcode gate; the same
            page becomes the admin panel with the separate admin username + password. */}
        <Route path="/placement" element={<Intake />} />
        {/* v2 of the placement diagnostic, three axes, ceiling plus a slider the member sets */}
        <Route path="/placement2" element={<Intake2 />} />
        <Route path="/intake" element={<Navigate to="/placement" replace />} />
        {/* Explore sleeve: Top-10 cap-weighted (25% cap, quarterly) calculator. Open, no gate. */}
        <Route path="/top10" element={<Top10 />} />
        {/* Legacy /memberview now forwards to the GT2-powered /newmemberview */}
        <Route path="/memberview" element={<Navigate to="/newmemberview" replace />} />
        <Route path="/newmemberview" element={<NewMemberView />} />
        {/* Catch-all: anything we don't recognize -> GT2 frontdoor */}
        <Route path="*" element={<Navigate to="/newmemberview" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
